import React, { useContext, useEffect } from 'react';
import './style.scss';
import clsx from 'clsx';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { SearchContext } from './context/SearchContext';
import Button from '../controls/Button';
import SearchItem from '../SearchItem';

const MINIMUM_CHARACTERS_ALLOWED_TO_SEARCH = 3;
const GlobalSearchComponent = () => {
  const {
    indexName,
    t,
    pagination,
    language,
    hasPagination,
    templateName,
    pageSize,
    placeholder,
    inputLabel,
    searchTerm,
    setSearchTerm,
    startSearchCharatersLength,
    helpers,
    isOpen,
    setIsOpen,
    wordsNotFoundError,
    setWordsNotFoundError,
    setDataRetrievedItems,
    dataRetrievedItems,
    focusedIndex,
    setFocusedIndex,
    getSearchSuggestions,
    summaryText,
    fromPopup,
    resultPage,
    inputSearchRef,
    openInSamePage,
    facetOn,
    setFilterVariable,
    totalSearchResultsCount,
    setPagination,
    setCurrentSearchCategory,
    setCurrentCategory = null,
    setSelectedCategory = null,
  } = useContext(SearchContext);

  const isAllowedToSearch =
    searchTerm !== '' && searchTerm?.length >= MINIMUM_CHARACTERS_ALLOWED_TO_SEARCH;

  useEffect(() => {
    document.body.addEventListener('click', onbodyClick);

    return () => {
      document.body.removeEventListener('click', onbodyClick);
    };
  }, []);

  const onbodyClick = () => {
    setIsOpen(false);
  };
  /***/
  //when changing the keyword we should change 'searchKeyword' in order to get the
  //resutls from the graphql reltated to search 'offerListingSearchFilter.graphql'
  const handleKeywordChange = () => {
    //get the keyword
    let keyword = inputSearchRef?.current?.value?.replace(/\\/g, '');

    setSearchTerm(keyword);
    if (keyword === '') {
      setWordsNotFoundError(false);
      setDataRetrievedItems([]);
      setFocusedIndex(-1);
      setIsOpen(false);
      return null;
    } else {
      if (keyword.length >= startSearchCharatersLength) {
        //we start the search after a defined characters

        let pageSizeValue = pageSize?.value || pageSize;
        if (!openInSamePage) {
          //for the popup
          helpers({
            getSearchSuggestions,
            indexName,
            templateName,
            language,
            pagination,
            keyword,
            hasPagination,
            pageSize: pageSizeValue + 1,
          });
        } else {
          //for the search results page
          let newPagination = {
            ...pagination,
            currentPage: 1,
          };
          helpers({
            getSearchSuggestions,
            indexName,
            templateName,
            language,
            pagination: newPagination,
            keyword,
            hasPagination: false,
            pageSize: null,
          });
        }
        setFocusedIndex(-1);
      }
    }
  };
  //search with graphql only for keywords
  const handleKeywordSearchButtonClick = () => {
    let keyword = inputSearchRef?.current?.value;

    if (fromPopup) {
      //go to search detail page with the query string of the text
      window.location.href = `${resultPage?.value?.href}?keyword=${keyword}`;
    } else {
      let pageSizeValue = pageSize?.value || pageSize;
      if (!openInSamePage) {
        let refetch = true;
        helpers({
          getSearchSuggestions,
          indexName,
          templateName,
          language,
          pagination,
          keyword,
          refetch,
          hasPagination,
          pageSize: pageSizeValue,
        });
      } else {
        let newPagination = {
          ...pagination,
          currentPage: 1,
          hasPrevious: true,
          hasNext: 2 < pagination?.pagesTotalNumber,
        };

        helpers({
          pagination: newPagination,
          indexName,
          templateName,
          language,
          keyword: keyword || inputSearchRef?.current?.value,
          facetOn,
          hasPagination: true,
          pageSize: pageSizeValue,
          setFilterVariable,
        });
        setCurrentSearchCategory(inputSearchRef?.current?.value);
        setPagination(newPagination);
        setCurrentCategory(t('All'));
        setSelectedCategory(0);
      }
      setIsOpen(false);
      setFocusedIndex(-1);
    }
  };

  const handleKeywordSearchButtonKeyPress = () => {
    if (focusedIndex !== -1) {
      window.location.href = dataRetrievedItems[focusedIndex]?.item?.url;
    } else {
      let keyword = inputSearchRef?.current?.value;

      if (fromPopup) {
        //go to search detail page with the query string of the text
        window.location.href = `${resultPage?.value?.href}?keyword=${keyword}`;
      } else {
        let pageSizeValue = pageSize?.value || pageSize;
        if (!openInSamePage) {
          let refetch = true;
          helpers({
            getSearchSuggestions,
            indexName,
            templateName,
            language,
            pagination,
            keyword,
            refetch,
            hasPagination,
            pageSize: pageSizeValue + 1,
          });
        } else {
          let newPagination = {
            ...pagination,
            currentPage: 1,
            hasNext: true,
            hasPrevious: false,
          };
          helpers({
            getSearchSuggestions,
            indexName,
            templateName,
            language,
            pagination: newPagination,
            keyword,
            hasPagination: false,
            pageSize: pageSizeValue + 1,
          });
        }

        setIsOpen(false);
        setFocusedIndex(-1);
      }
    }
  };

  const handleCancelSearchClick = () => {
    setSearchTerm('');
    setFocusedIndex(-1);
    setIsOpen(false);
    setWordsNotFoundError(false);
  };
  /***/
  const handleKeyUpOnSearchInput = (e) => {
    let maxItems = pageSize?.value;
    if (dataRetrievedItems?.length < pageSize?.value) {
      maxItems = dataRetrievedItems?.length;
    }
    if (!!e && e.key === 'ArrowDown' && focusedIndex + 2 <= maxItems) {
      if (focusedIndex < pageSize?.value) {
        setFocusedIndex((prev) => prev + 1);
      }
    }
    if (!!e && e.key === 'ArrowUp' && focusedIndex - 1 !== -1) {
      setFocusedIndex((prev) => prev - 1);
    }
    if (e?.current?.value?.length > startSearchCharatersLength) {
      handleKeywordChange(e);
    }
  };

  return (
    <div className="generic-search global-search-theme">
      <FormControl fullWidth sx={{ m: 0 }}>
        <InputLabel htmlFor="outlined-adornment-amount">{inputLabel?.value}</InputLabel>
        <OutlinedInput
          className="input-mui-search"
          inputRef={inputSearchRef}
          onKeyPress={(e) =>
            e.key === 'Enter' && isAllowedToSearch && handleKeywordSearchButtonKeyPress()
          }
          onKeyUp={(e) => handleKeyUpOnSearchInput(e)}
          onChange={(e) => handleKeywordChange(e)}
          id="outlined-adornment-amount"
          value={searchTerm}
          label={inputLabel?.value}
          placeholder={placeholder?.value}
        />
        <div className="icon-search flex-it flex-align-item-center">
          <img src={'/-/jssmedia/Project/FAB2/shared/images/icon_search-blue.svg'} />
        </div>
        <div
          id={`Search-${fromPopup ? 'popup' : ''}-id`}
          className={clsx('searchItems-box box-type', isOpen ? 'open' : '')}
        >
          {dataRetrievedItems?.length > 0 && <div className="arrow-top"></div>}
          {dataRetrievedItems?.length > 0 &&
            dataRetrievedItems?.slice(0, pageSize?.value)?.map((item, index) => {
              let title = item?.category;
              let subTitle = {
                value: t('in') + ' ' + (item?.item?.title?.value || item?.item?.name),
              };

              return (
                <SearchItem
                  item={item}
                  key={index}
                  index={index}
                  searchWord={inputSearchRef?.current?.value}
                  title={title}
                  subTitle={subTitle}
                  focusedIndex={focusedIndex}
                />
              );
            })}

          {dataRetrievedItems?.length > pageSize?.value && (
            <div className="footer-results">
              <div className="auto">
                <div className="view-all">
                  <Button
                    onClick={handleKeywordSearchButtonClick}
                    fullWidth={false}
                    color="secondary"
                    variant="contained"
                    arrow="right"
                    className="btn-view-all"
                  >
                    {t('viewAllResults')}
                  </Button>
                </div>

                <div className="results-count flex-it flex-align-item-center">
                  <div className="text-count">
                    {t(summaryText).replace('{0}', totalSearchResultsCount)}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div
          className={clsx(
            'no-search-results box-type flex-it flex-align-item-center',
            wordsNotFoundError && searchTerm !== '' ? 'open' : ''
          )}
        >
          {wordsNotFoundError && searchTerm !== '' && <div className="arrow-top"></div>}

          <div className="auto flex-it flex-align-item-center">
            <div className="image-error">
              <img src={`/-/media/Project/FAB2/shared/images/ico_exclamation-red.svg`} />
            </div>
            <div className="text">
              {t('offerCategoryFilterNoResult').replace('{0}', `'${searchTerm}'`)}
            </div>
          </div>
        </div>
      </FormControl>

      <div
        className={clsx(
          'search-actions flex-it flex-align-item-center',
          isAllowedToSearch ? '' : 'disabled'
        )}
      >
        {fromPopup && (
          <div className="close-search" onClick={handleCancelSearchClick}>
            <img src={'/-/jssmedia/Project/FAB2/shared/images/ico_closeCircle-blue.svg'} />
          </div>
        )}
        <Button
          onClick={handleKeywordSearchButtonClick}
          variant="contained"
          className="panel-right__link search-btn"
          fullWidth={false}
        >
          <span className="desktop"> {t('search')}</span>
          <span className="mobile">
            <img src={'/-/jssmedia/Project/FAB2/Fab2/data/media/svgs/icons/search.svg'} />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default GlobalSearchComponent;
